var render = function render(){var _vm=this,_c=_vm._self._c;return _c('warranty-film-type-list',_vm._b({},'warranty-film-type-list',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }